// eslint-disable-next-line @typescript-eslint/no-namespace
export namespace RentsDataConfig {
    export const maxLookbackYears = 5;
}